export default __webpack_public_path__ + "static/media/illustration-work-1-m@2x.df687933.webp";